import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { DisableAdminAccessGuard } from '@core/guards/disableAdminAccess.guard';
import { DisableProductionAccessGuard } from '@core/guards/disableProductionAccess.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/product/catalog',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    loadComponent: () => import('./modules/admin/admin.component'),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'settings',
        loadComponent: () =>
          import('./modules/admin/pages/settings/settings.component'),
        canActivate: [AuthGuard],
      },
      {
        path: 'company-manager',
        loadComponent: () =>
          import(
            './modules/admin/pages/company-manager/company-manager.component'
          ),
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'company-manager' },
    ],
  },
  {
    path: 'product',
    loadComponent: () => import('./modules/product/product.component'),
    canActivate: [AuthGuard, DisableAdminAccessGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./modules/product/pages/dashboard/dashboard.component'),
      },
      {
        path: 'catalog',
        loadComponent: () =>
          import('./modules/product/pages/catalog/catalog.component'),
      },
      {
        path: 'detail/:id',
        loadComponent: () =>
          import(
            './modules/product/pages/product-detail/product-detail.component'
          ).then((m) => m.ProductDetailComponent),
      },
    ],
  },
  {
    path: 'downloads',
    loadComponent: () =>
      import('./modules/downloads/downloads.component').then(
        (m) => m.DownloadsComponent
      ),
    canActivate: [
      AuthGuard,
      DisableAdminAccessGuard,
      DisableProductionAccessGuard,
    ],
  },
  {
    path: 'load-history',
    loadComponent: () =>
      import('./modules/loadHistory/loadHistory.component').then(
        (m) => m.LoadHistoryComponent
      ),
    canActivate: [AuthGuard, DisableProductionAccessGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/login/pages/login/login.component'),
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './modules/login/pages/login/components/login-form/login-form.component'
          ),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import(
            './modules/login/pages/login/components/forgot-password-form/forgot-password-form.component'
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import(
            './modules/login/pages/login/components/reset-password-form/reset-password-form.component'
          ),
      },
      {
        path: 'refresh-password',
        loadComponent: () =>
          import(
            './modules/login/pages/login/components/refresh-password-form/refresh-password-form.component'
          ),
      },
    ],
  },
  {
    path: 'company',
    loadComponent: () => import('./modules/company/company.component'),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'settings',
        loadComponent: () =>
          import('./modules/company/pages/settings/settings.component'),
        children: [
          {
            path: 'aside-menu',
            loadComponent: () =>
              import(
                './modules/company/pages/settings/components/aside-menu/aside-menu.component'
              ),
          },
        ],
      },
    ],
  },
];
